import React, { useCallback, useEffect, useRef } from 'react';
import '../styles/processForm.css';

export function CompletionMark() {
  return <div className="process-completion-mark" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="m6 12 4 4 8-8" /></svg>
  </div>;
}

export default function ProcessCompletion({ onClose }) {
  const latestClose = useRef(onClose);
  const finished = useRef(false);
  latestClose.current = onClose;
  const canClose = typeof onClose === 'function';
  const finish = useCallback(() => {
    if (finished.current || !latestClose.current) return;
    finished.current = true;
    latestClose.current();
  }, []);
  useEffect(() => {
    if (!canClose) return undefined;
    const timer = setTimeout(finish, 3000);
    return () => clearTimeout(timer);
  }, [canClose, finish]);
  return <div className="process-form process-completion" role="status">
    {onClose && <button type="button" onClick={finish} aria-label="Fechar" autoFocus className="absolute right-5 top-5 grid h-9 w-9 place-items-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 focus-visible:outline-blue-500"><span aria-hidden="true">×</span></button>}
    <CompletionMark />
    <h1 className="text-3xl font-semibold text-slate-900">Processo concluído</h1>
  </div>;
}
